import { AnyIfEmpty } from "react-redux";
import { GET_KIOSK_STATUS_FAILURE, GET_KIOSK_STATUS_REQUEST, GET_KIOSK_STATUS_SUCCESS } from "../constants/kiosk-status.constants";

const initialState = {
    loading: false,
    data: [],
    errorMsg: '',
};

export const kioskStatusReducer = (state = initialState, action: AnyIfEmpty<object>) => {
    switch (action.type) {
        case GET_KIOSK_STATUS_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case GET_KIOSK_STATUS_SUCCESS:
            return {
                ...state,
                loading: false,
                data: action.payload,
            };
        case GET_KIOSK_STATUS_FAILURE:
            return {
                ...state,
                loading: false,
                errorMsg: action.payload,
            };

        default:
            return state;
    }
};